<template>
  <v-container fluid class="px-0 pt-0">
    <Loading v-if="isLoading"/>
    <v-row class="px-8 py-4 topBar">
      <v-spacer></v-spacer>
      <v-col cols="4" class="text-right">
        <div class="d-flex align-center justify-end">
          <span class="mr-4">Recherche par :</span>
          <v-select
          v-model="searchBy"
          :items="listSearch"
          hide-details
          outlined
          max-width="100"
          style="max-width: 100px"
        ></v-select>
        </div>
      </v-col>

      <v-col cols="2">
        <v-text-field hide-details outlined dense v-model="searchText" @keyup.enter="() => search()">
          <template v-slot:append>
            <v-btn depressed color="primary" class="topBar-search ma-0"
            @click="search"
            >
              <v-icon v-text="'$search'"></v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </v-col>
    </v-row>

    <v-simple-table class="table-full table-fixed-height" :fixed-header= "true">
      <thead>
        <tr>
          <th rowspan="2">ID</th>
          <th rowspan="2">Date</th>
          <th rowspan="2">Client</th>
          <th colspan="6" class="border-col">Nombre de contact</th>

          <th rowspan="2">Montant</th>
          <th rowspan="2">Générer</th>
<!--          <th rowspan="2">Devis envoyé</th>-->
        </tr>
        <tr>
          <th>Telephone</th>
          <th>Email</th>
          <th>Postal</th>
          <th>Push Notif Navigateur</th>
          <th>Push Notif App</th>
          <th>FB messenger</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="item in items">
          <td>{{ item.invoiceNumber }}</td>
          <td>{{ item.createdAt | moment('DD/MM/YYYY')}}</td>
          <td>{{ item.client }}</td>
          <td>{{ item.telephone }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.postal }}</td>
          <td>{{ item.pushBrowser }}</td>
          <td>{{ item.pushApp }}</td>
          <td>{{ item.fbMessage }}</td>
          <td>{{ item.totalPrice }} €</td>
          <td style="width: 200px;">
           <ExportData :invoiceId="item.id" :componentName="'comptage'" @deleteInvoice="deleteInvoice"/>
          </td>
<!--          <td>-->
<!--            <v-menu :close-on-content-click="false" :nudge-width="100" offset-y>-->
<!--              <template v-slot:activator="{ on }">-->
<!--                <span class="headline btn-quest min-width-btn" v-on="on">-->
<!--                  <i class="fal fa-question-circle fa-sm" @click="quotation(item.id)"></i>-->
<!--                </span>-->
<!--              </template>-->
<!--            </v-menu>-->
<!--          </td>-->
        </tr>
      </tbody>
    </v-simple-table>

    <div class="mt-4 mb-1 mx-4" v-if="totalItems > 0">
      <div class="d-flex align-center">
        <span class="mr-4">Affichage</span>
        <v-select
          v-model="limit"
          :items="itemPerPageList"
          hide-details
          dense
          outlined
          style="max-width: 90px"
        ></v-select>
        <span class="ml-4 mr-2">sur {{ totalItems }} items par page</span>
        <v-pagination class="justify-start" v-model="page" :length="totalPage"></v-pagination>
      </div>
    </div>
  </v-container>
</template>
<script>
import { mapState } from 'vuex';
import QuotationService from '../../services/quotation.service';
import Loading from '../../components/Loading.vue';
import ExportData from '../../components/ExportData.vue';

export default {
  name: "ComptagesSauvegardes",
  data: () => ({
    isLoading: false,
    page: 1,
    totalPage: 1,
    items: [],
    limit: 50,
    totalItems: 0,
    searchText: '',
    searchBy: 'id',
    selectedId : null,
    listSearch:[
      {
        text: 'ID',
        value: 'invoiceNumber'
      },
      {
        text: 'Client',
        value: 'c.name'
      }
    ]
  }),
  components: {
    Loading,
    ExportData,
  },
  computed: {
   ...mapState({
      itemPerPageList: state => state.pagination.itemPerPageList,
      itemPerPage: state => state.pagination.itemPerPage
    }),
  },
  created() {
    this.fetch();
  },
  methods: {
    async quotation(invoiceId){
      if (!await this.confirm('Confirmez-vous cette action ?')) {
        return;
      }

      const response = await QuotationService.updateStatus({
        invoiceId: invoiceId,
        name: 'quotationStatus',
        value: 2
      });

      if(response.data.status == 'success') {
        this.items = this.items.filter(item => item.id != invoiceId);
      }
    },
    deleteInvoice(invoiceId){
      this.items = this.items.filter(item => item.id != invoiceId);
    },
    async fetch(cb = null) {

      this.isLoading = true;
      try {
        const response = await QuotationService.getPagedResult(
          {
            page: this.page,
            limit: this.limit,
            searchText: this.searchText,
            searchBy: this.searchBy
          }
        );
        this.items = response.data.data;
        this.totalItems = response.data.total;
        this.totalPage = response.data.totalPage;
        if (typeof (cb) === 'function') {
          cb();
        }
      } catch (e) {
        this.$notification.error(e.response.data.error.message);
      }
      this.isLoading = false;
    },
    search(){
      this.fetch();
    },
    onClientAdded(id) {
      this.fetch();
    }
  },
  watch:{
    page(item){
        this.page = item;
        this.fetch();
    },
    limit(item){
        this.fetch();
    }
  }
};
</script>

